import React from 'react';
import { EventUI } from '../models/UIModels/Event.ui';
import { Event } from '../models/Event';

import { EventContext } from '../Contexts/EventProvider';
import { Skeleton } from 'primereact/skeleton';

const App: React.FC = () => {
    const { upCommingEvents, pastEvents, events } = React.useContext(EventContext);
    const [loading, setLoading] = React.useState<boolean>(true);

    React.useEffect(() => {
        if (events.length > 0) {
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }else{
          setLoading(true);
        }
    }, [events]);
    const skelleton = (amount: number) => {
      // return 12 skeleton items
      return Array.from({length: amount}).map((_, index) => (
          <div key={index} className="col-md-4 case-item">
              <Skeleton width="100%" height="400px"/>
          </div>
      ));
  }
    return (
        <div className="row justify-content-center mt-3">
          <div className="col-md-10 mw-content-page px-0">
          <h2>Aktuelle arrangementer:</h2>
          <div className="row event-overview mb-5">
          {loading ? (
                    skelleton(events.length > 0 ? events.length : 12)
                ) : (
                upCommingEvents.length != 0 ? (
            upCommingEvents.map((event, index) => (
                 <EventUI event={event} key={index} />
                ))
                ):(
                  <p>Pt. ingen aktuelle arrangementer</p>
                ))}
          
          </div>
          {pastEvents ? (
             <>
             <h2>Tidligere arrangementer:</h2>
             <div className="row event-overview mb-5 past-events">
             {pastEvents.map((event, index) => (
                    <EventUI event={event} key={index} />
                 ))}
             </div>
             </>
             ) : (
                <>
                <p>Pt. ingen Tidligere arrangementer</p>
                </>
                )}
          
          </div>
        </div>
    );
};

export default App;